<div class="relative">
  <tui-loader [overlay]="true" [showLoader]="isLoading">
    <div class="container">
      <div class="flex gap-3 border-b border-b-[#bb0021] pb-2">
        <button style="cursor: pointer" class="p-2" (click)="navigateToView()">
          <tui-svg
            src="tuiIconArrowLeftCircleLarge"
            style="color: black"
            class="hover:scale-110 transition-all duration-100"
          ></tui-svg>
        </button>
        <p class="flex items-center text-black text-[1.5rem] font-bold">
          Add Attendance
        </p>
      </div>

      <div
        class="flex items-center justify-center xl:justify-normal mt-5 2xl:my-10 lg:ml-10"
      >
        <div class="w-full sm:w-[400px]">
          <form [formGroup]="attendanceForm">
            <div class="">
              <div class="mt-4">
                <label class="text-black">Select Date</label>
                <tui-input-date
                  [max]="currentDate"
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  [style.text-align]="'left'"
                  class="tui-space_top-1"
                  formControlName="date"
                >
                  Choose a date
                  <input autocomplete="dob" tuiTextfield type="text" />
                </tui-input-date>
                <tui-error
                  formControlName="date"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <div class="mt-4">
                <label class="text-black">Select Member</label>
                <tui-multi-select
                  formControlName="member"
                  [stringify]="memberStringify"
                >
                  <tui-data-list-wrapper *tuiDataList [items]="filter(search)">
                  </tui-data-list-wrapper>
                  Member
                </tui-multi-select>
                <tui-error
                  formControlName="member"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <div class="mt-4">
                <label class="text-black">Select Session</label>
                <tui-select
                  class="b-form"
                  formControlName="session"
                  [tuiTextfieldLabelOutside]="true"
                >
                  Session
                  <tui-data-list-wrapper
                    *tuiDataList
                    [items]="sessions"
                  ></tui-data-list-wrapper>
                </tui-select>
                <tui-error
                  formControlName="session"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>
            </div>

            <div class="flex gap-3 mt-5">
              <div class="w-full h-full">
                <button
                  (click)="cancel()"
                  tuiButton
                  appearance="secondary"
                  type="button"
                  class="w-full h-full text-[#bb0021] hover:bg-[#faf0f2] hover:text-[#bb0021]"
                >
                  Cancel
                </button>
              </div>
              <div class="w-full">
                <button
                  tuiButton
                  type="button"
                  class="w-full"
                  (click)="submit()"
                >
                  <span class="text-white">Add Attendance</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </tui-loader>
</div>
